import React, {createContext, ReactNode, useMemo} from 'react'
import {useThemeContext} from '@view/theme/context/hooks/useThemeContext'
import {useAppContext} from '@context/appContext/hooks/useAppContext'
import {useUserStyleQuery} from '@containers/accountStyle/queryHooks/useUserStyleQuery'
import {buildAccountStyleTokens, parseMenuColor} from '@containers/accountStyle/helpers/buildAccountStyleTokens'
import {DEFAULT_ACCOUNT_MENU_COLOR} from '@containers/accountStyle/constants/palette'
import {IAccountStyleContext} from '@containers/accountStyle/types'

export const AccountStyleContext = createContext<IAccountStyleContext | null>(null)

interface IProps {
	children: ReactNode
}

export const AccountStyleProvider = ({children}: IProps) => {
	const {theme} = useThemeContext()
	const {settings} = useAppContext()
	const {data} = useUserStyleQuery()

	const userMenuColor = parseMenuColor(data?.menuColor)
	// track renders the resolved colour into the page, so the first paint needs no request.
	const menuColor = (data ? userMenuColor ?? parseMenuColor(data.accountMenuColor) : parseMenuColor(settings?.menuColor))
		?? DEFAULT_ACCOUNT_MENU_COLOR

	const value = useMemo(() => ({
		menuColor,
		userMenuColor,
		tokens: buildAccountStyleTokens(menuColor, theme),
	}), [menuColor, userMenuColor, theme])

	return (
		<AccountStyleContext.Provider value={value}>
			{children}
		</AccountStyleContext.Provider>
	)
}

export default AccountStyleProvider
